import { Editor, Point, Transforms, Range, Element, Node, Path, Text } from "slate";

const withControls = (editor) => {

    const { isInline, deleteBackward, deleteForward } = editor;

    editor.deleteBackward = (unit) => {
        const { selection } = editor;
        if (selection) {
            try {
                const { anchor } = selection;
                const { offset } = anchor;
                const [prevNode, prevPath] = Editor.previous(editor, { at: selection.anchor.path });
                if (prevNode && prevNode.type === 'control' && !offset) {
                    Transforms.removeNodes(editor, { at: prevPath });
                    return
                }
            } catch (error) {
            }
        }
        deleteBackward(unit);
    };

    editor.deleteForward = (unit) => {
        const { selection } = editor
        if (selection) {
            try {
                const [start, end] = Range.edges(selection);
                const endOfNode = Editor.end(editor, start.path);
                const nodeNext = Editor.next(editor, { at: selection.anchor.path });
                const [nextNode, nextPath] = nodeNext;
                if (end.offset === endOfNode.offset && nextNode && nextNode.type === 'control') {
                    Transforms.removeNodes(editor, { at: nextPath });
                    return

                }
            } catch (error) {
            }
        }
        deleteForward(unit)
    }


    editor.isInline = (element) =>
        element.type === 'control' ? true : isInline(element);
    return editor;
};

export default withControls;